"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSize = getSize;
/* Sizing scale */
// See: https://github.com/nib-group/design-system/blob/master/packages/icons/src/scripts/createReactPackage.ts#L66C1-L75C3
const sizes = {
  mini: 12,
  xs: 16,
  sm: 24,
  md: 32,
  lg: 48,
  xl: 64,
  xxl: 96,
  xxxl: 128
};
function getSize(size) {
  if (typeof size === "number") {
    return size;
  }
  return sizes[size];
}